import TemplateView from "../../../../TemplateView"
import BreadcrumbsPanel from "./BreadcrumbsPanel"
import EntitiesListHeader from "./EntitiesListHeader"
import LoadingSpinner from "../../../../components/LoadingSpinner"
import Header from "./Header"
import messageResource from '../../../../messageResource'
import {formatFmlWithCheck} from "../../../../util/UserNameFormat"
import EntitiesList from "./EntitiesList"
import {HierarchyLevels} from "constants"
import AutoScrollableWrapper from '../../../../taskManagement/kanban/components/AutoScrollableWrapper'
import LoadingSpinnerWrapper from './LoadingSpinnerWrapper'
import LoadingContainer from '../../../../util/LoadingContainer'
import RevokeMenu from './RevokeMenu'
import {HIERARCHY_LEVEL_CLASSES} from '../../../../components/counterCPT/constants'
import {anyInSet} from '../../../../atUtils'
import {hasAccessAllManagementScope} from '../../../../loggedInUser/selectors'

export default class HierarchyAssignmentsEditor extends TemplateView {
    constructor({
        headerMessageKey = '',
        workAssignmentsVisible = true,
        managementAssignmentsEditable = true,
        showOnlyActiveSwitch = false,
        showAllExistingFuturesSwitcher = false,
        changeCustomerAssignment = (customerId, assigned) => {},
        changeProjectAssignment = (projectId, assigned) => {},
        changeTaskAssignment = (taskId, assigned) => {},
        changeAllCustomersAssignments = assigned => {},
        changeAllProjectsAssignments = assigned => {},
        changeAllTasksAssignments = assigned => {},
        changeAllExistingAndFutureTasksAssignment = assigned => {},
        changeAllExistingAndFutureProjectsAssignment = assigned => {},
        deselectCustomer = () => {},
        deselectProject = () => {},
        selectCustomer = (customerId) => {},
        selectProject = (projectId) => {},
        reloadCustomers = () => {},
        loadMoreEntities = () => {},
        changeOnlyActive = onlyActive => {},
        changeCustomersSearchText = text => {},
        clearCustomersSearchText = () => {},
        changeProjectsSearchText = text => {},
        clearProjectsSearchText = () => {},
        changeTasksSearchText = text => {},
        clearTasksSearchText = () => {},
        closeEditor = () => {},
        getAssignAllTextsMap = () => {},
        getRevokeAllTextsMap = () => {},
        getAssignTextsMap = () => {},
        getRevokeTextsMap = () => {},
    }) {
        super()

        this.params = {
            headerMessageKey,
            workAssignmentsVisible,
            managementAssignmentsEditable,
            showOnlyActiveSwitch,
            showAllExistingFuturesSwitcher,
            getAssignAllTextsMap,
            getRevokeAllTextsMap,
            getAssignTextsMap,
            getRevokeTextsMap,
        }

        this.callbacks = {
            changeCustomerAssignment,
            changeProjectAssignment,
            changeTaskAssignment,
            changeAllCustomersAssignments,
            changeAllProjectsAssignments,
            changeAllTasksAssignments,
            deselectCustomer,
            deselectProject,
            selectCustomer,
            selectProject,
            loadMoreEntities,
            changeOnlyActive,
            changeCustomersSearchText,
            clearCustomersSearchText,
            changeProjectsSearchText,
            clearProjectsSearchText,
            changeTasksSearchText,
            clearTasksSearchText,
            changeAllExistingAndFutureTasksAssignment,
            changeAllExistingAndFutureProjectsAssignment,
            closeEditor,
        }

        this.state = {
            viewerCanManageCustomerIds: {},
            viewerCanManageProjectIds: {},
            user: {},
            customers: [],
            projects: [],
            tasks: [],
            canWorkCustomerIds: {},
            canManageCustomerIds: {},
            canManageCustomerExcludeSelfIds: {},
            canWorkProjectIds: {},
            canManageProjectIds: {},
            canManageProjectExcludeSelfIds: {},
            canWorkTaskIds: {},
            canManageTaskIds: {},
            projectCountsByCustomers: {},
            taskCountsByCustomers: {},
            taskCountsByProjects: {},
            futureCustomersAssigned: false,
            someCustomersOrLowerAssigned: false,
            allCustomersAssigned: false,
            futureProjectsAssigned: false,
            someProjectsOrLowerAssigned: false,
            allProjectsAssigned: false,
            futureTasksAssigned: false,
            someTasksAssigned: false,
            allTasksAssigned: false,
            selectedCustomer: null,
            selectedProject: null,
            loading: false,
            changingCustomerAssignments: {},
            changingProjectAssignments: {},
            changingTaskAssignments: {},
            changingAllAssignments: false,
            onlyActive: false,
            customersSearchOpen: false,
            customersSearchText: '',
            projectsSearchOpen: false,
            projectsSearchText: '',
            tasksSearchOpen: false,
            tasksSearchText: '',
            searchOpen: false,
            searchText: '',
            canManageParentCustomer: false,
            canManageParentProject: false,
            viewerHasAccessAllManagementScope: false,
        }

        this.onStateDeeplyChanged(state => {
            this.header.setState({
                name: formatFmlWithCheck(state.user || {})
            })

            this.breadcrumbsPanel.setState({
                customerName: state.selectedCustomer ? state.selectedCustomer.name : '',
                projectName: state.selectedProject ? state.selectedProject.name : '',
            })

            this._setHierarchyBackButtonText(state.selectedCustomer, state.selectedProject)

            const canManageAnyCustomer = state.viewerHasAccessAllManagementScope || anyInSet(state.viewerCanManageCustomerIds)
            const allCustomersCheckboxTooltipText = canManageAnyCustomer ? '' : messageResource.getEscapedMessage('work_assignments.tooltip.disabled_all_assign_button_customer')

            this.customersList.toggle(!state.selectedCustomer && !state.selectedProject)
            this.customersListHeader.toggle(!state.selectedCustomer && !state.selectedProject)
            this.customersListHeader.setState({
                allAssigned: state.allCustomersAssigned,
                someAssigned: state.someCustomersOrLowerAssigned,
                onlyActive: state.onlyActive,
                searchOpen: state.customersSearchOpen,
                searchText: state.customersSearchText,
                changingAllAssignments: state.changingAllAssignments,
                futureAssigned: state.futureCustomersAssigned,
                listIsEmpty: state.customers.length === 0,
                disabledCheckboxTooltipText: allCustomersCheckboxTooltipText,
                isAssignAllCheckboxDisabled: !canManageAnyCustomer,
            })
            this.customersList.setState({
                entities: state.customers,
                canWorkIds: state.canWorkCustomerIds,
                canManageIds: state.canManageCustomerIds,
                canManageExcludeSelfIds: state.canManageCustomerExcludeSelfIds,
                projectCounts: state.projectCountsByCustomers,
                taskCounts: state.taskCountsByCustomers,
                changingAssignments: state.changingCustomerAssignments,
                futureAssigned: state.futureCustomersAssigned,
            })

            let futureProjectsSwitcherTooltipText = ""
            let allProjectsCheckboxTooltipText = ""
            let projectCheckboxTooltipText = ""
            let isAllProjectsCheckboxDisabled = false

            if (state.canManageParentCustomer) {
                futureProjectsSwitcherTooltipText = this._getCannotChangeThisOption({targetCP: messageResource.getMessage("common.customer")})
                allProjectsCheckboxTooltipText = futureProjectsSwitcherTooltipText
                projectCheckboxTooltipText = this._getCannotUnassign({
                    targetPT: messageResource.getMessage('common.project'),
                    selectedCP: messageResource.getMessage('common.customer'),
                })
                isAllProjectsCheckboxDisabled = true
            } else if (!this.params.workAssignmentsVisible && state.futureProjectsAssigned
                       || !!state.selectedCustomer && state.canManageCustomerExcludeSelfIds[state.selectedCustomer.id]) {
                futureProjectsSwitcherTooltipText = ""
                allProjectsCheckboxTooltipText = this._getCannotChangeThisOptionExistingAndFuture({
                    existingAndFutures: messageResource.getMessage('common.projects'),
                    selectedCP: messageResource.getMessage('common.customer'),
                })
                projectCheckboxTooltipText = this._getCannotUnassignExistingAndFutures({
                    targetPT: messageResource.getMessage('common.project'),
                    existingAndFutures: messageResource.getMessage('common.projects'),
                    selectedCP: messageResource.getMessage('common.customer'),
                })
                isAllProjectsCheckboxDisabled = true
            } else if (this.params.workAssignmentsVisible && !state.viewerHasAccessAllManagementScope && !anyInSet(state.viewerCanManageProjectIds)) {
                allProjectsCheckboxTooltipText = messageResource.getEscapedMessage('work_assignments.tooltip.disabled_all_assign_button_project')
                isAllProjectsCheckboxDisabled = true
            }

            this.projectsListHeader.toggle(!!state.selectedCustomer && !state.selectedProject)
            this.projectsList.toggle(!!state.selectedCustomer && !state.selectedProject)
            this.projectsListHeader.setState({
                allAssigned: state.allProjectsAssigned || !this.params.workAssignmentsVisible && state.futureProjectsAssigned,
                someAssigned: state.someProjectsOrLowerAssigned,
                onlyActive: state.onlyActive,
                searchOpen: state.projectsSearchOpen,
                searchText: state.projectsSearchText,
                changingAllAssignments: state.changingAllAssignments,
                futureAssigned: state.futureProjectsAssigned,
                disabledSwitcherTooltipText: futureProjectsSwitcherTooltipText,
                disabledCheckboxTooltipText: allProjectsCheckboxTooltipText,
                listIsEmpty: state.projects.length === 0,
                isAssignAllCheckboxDisabled: isAllProjectsCheckboxDisabled,
            })
            this.projectsList.setState({
                entities: state.projects,
                canWorkIds: state.canWorkProjectIds,
                canManageIds: state.canManageProjectIds,
                canManageExcludeSelfIds: state.canManageProjectExcludeSelfIds,
                taskCounts: state.taskCountsByProjects,
                changingAssignments: state.changingProjectAssignments,
                topLevelAccess: state.canManageParentCustomer,
                readOnlyTooltipText: projectCheckboxTooltipText,
                futureAssigned: state.futureProjectsAssigned,
            })


            let futureTasksSwitcherTooltipText = ""
            let allTasksCheckboxTooltipText = ""
            let taskCheckboxTooltipText = ""
            let isAllTaskCheckboxDisabled = false

            if (state.canManageParentCustomer) {
                futureTasksSwitcherTooltipText = this._getCannotChangeThisOption({targetCP: messageResource.getMessage("common.customer")})
                allTasksCheckboxTooltipText = futureTasksSwitcherTooltipText
                taskCheckboxTooltipText = this._getCannotUnassign({
                    targetPT: messageResource.getMessage('common.task'),
                    selectedCP: messageResource.getMessage('common.customer'),
                })
                isAllTaskCheckboxDisabled = true
            } else if (!this.params.workAssignmentsVisible && state.futureProjectsAssigned
                       || !!state.selectedCustomer && state.canManageCustomerExcludeSelfIds[state.selectedCustomer.id]
            ) {
                futureTasksSwitcherTooltipText = this._getCannotChangeThisOptionExistingAndFuture({
                    existingAndFutures: messageResource.getMessage("common.projects"),
                    selectedCP: messageResource.getMessage("common.customer"),
                })
                allTasksCheckboxTooltipText = futureTasksSwitcherTooltipText
                taskCheckboxTooltipText = this._getCannotUnassignExistingAndFutures({
                    targetPT: messageResource.getMessage('common.task'),
                    existingAndFutures: messageResource.getMessage('common.projects'),
                    selectedCP: messageResource.getMessage('common.customer'),
                })
                isAllTaskCheckboxDisabled = true
            } else if (state.canManageParentProject) {
                futureTasksSwitcherTooltipText = this._getCannotChangeThisOption({targetCP: messageResource.getMessage("common.project")})
                allTasksCheckboxTooltipText = futureTasksSwitcherTooltipText
                taskCheckboxTooltipText = this._getCannotUnassign({
                    targetPT: messageResource.getMessage('common.task'),
                    selectedCP: messageResource.getMessage('common.project'),
                })
                isAllTaskCheckboxDisabled = true
            } else if (!this.params.workAssignmentsVisible && state.futureTasksAssigned
                       || !!state.selectedProject && state.canManageProjectExcludeSelfIds[state.selectedProject.id]
            ) {
                futureTasksSwitcherTooltipText = ""
                allTasksCheckboxTooltipText = this._getCannotChangeThisOptionExistingAndFuture({
                    existingAndFutures: messageResource.getMessage("common.tasks"),
                    selectedCP: messageResource.getMessage("common.project"),
                })
                taskCheckboxTooltipText = this._getCannotUnassignExistingAndFutures({
                    targetPT: messageResource.getMessage('common.task'),
                    existingAndFutures: messageResource.getMessage('common.tasks'),
                    selectedCP: messageResource.getMessage('common.project'),
                })
                isAllTaskCheckboxDisabled = true
            }

            this.tasksListHeader.toggle(!!state.selectedCustomer && !!state.selectedProject)
            this.tasksList.toggle(!!state.selectedCustomer && !!state.selectedProject)
            this.tasksListHeader.setState({
                allAssigned: state.allTasksAssigned || !this.params.workAssignmentsVisible && state.futureTasksAssigned,
                someAssigned: state.someTasksAssigned,
                onlyActive: state.onlyActive,
                searchOpen: state.tasksSearchOpen,
                searchText: state.tasksSearchText,
                changingAllAssignments: state.changingAllAssignments,
                futureAssigned: state.futureTasksAssigned,
                disabledSwitcherTooltipText: futureTasksSwitcherTooltipText,
                disabledCheckboxTooltipText: allTasksCheckboxTooltipText,
                listIsEmpty: state.tasks.length === 0,
                isAssignAllCheckboxDisabled: isAllTaskCheckboxDisabled,
            })
            this.tasksList.setState({
                entities: state.tasks,
                canWorkIds: state.canWorkTaskIds,
                canManageIds: state.canManageTaskIds,
                changingAssignments: state.changingTaskAssignments,
                topLevelAccess: state.canManageParentProject,
                readOnlyTooltipText: taskCheckboxTooltipText,
                futureAssigned: state.futureTasksAssigned,
            })

            this._tryToShowNotFoundMessage()
        })
        this.onStatePropertyChanged('loading', loading => {
            this.loadingSpinnerWrapper.toggle(loading)
            this.loadingSpinner.setState({show: loading})
        })

        this.onStatePropertyChanged('changingAllAssignments', loading => this.listsLoadingWrapper.setState({loading}))

        this.onStateChanged(() => {
            this.scrollableWrapper.refreshScroll()
        })
    }

    messageKeys() {
        return {
            backButtonText: 'user.panel.permissions.team_assignments.back',
        }
    }

    templateHtml() {
        return "<div class='userManagement_components_hierarchyAssignmentsEditor'>" +
               '   <div class="headerPlaceholder">' +
               '        <div class="backButton">' +
               '            <div class="arrow"></div>' +
               '            <div class="text"></div>' +
               '        </div>' +
               '        <div class="headerText"></div>' +
               '   </div>' +
               "  <div class='content'>" +
               "     <div class='headers'></div>" +
               "     <div class='noFoundMessage'></div>" +
               "     <div class='lists' style='position: relative'></div>" +
               "  </div>" +
               "</div>"
    }

    afterRender() {
        const $content = this.find('.headers');

        this.header = new Header({
            messageKey: this.params.headerMessageKey
        }).init(this.find('.headerText'))

        this.$backButton = this.find('.backButton')
        this.$backButtonText = this.find('.text')

        this.$noFoundMessage = this.find('.noFoundMessage')
        this.noItemsInLevel = this.find('.noItemsInLevel')

        this.$backButton.click(() => {

            if(!this.state.selectedCustomer && !this.state.selectedProject) {
                this.callbacks.closeEditor()
            }

            if(!!this.state.selectedCustomer && !this.state.selectedProject) {
                this.callbacks.deselectCustomer()
            }

            if(!!this.state.selectedCustomer && !!this.state.selectedProject) {
                this.callbacks.deselectProject()
            }
        })

        this.breadcrumbsPanel = new BreadcrumbsPanel({
            onCustomerClose: () => this.callbacks.deselectCustomer(),
            onProjectClose: () => this.callbacks.deselectProject()
        }).init($content)

        this.revokeMenu = RevokeMenu.getInstance()

        this.customersListHeader = new EntitiesListHeader({
            title: messageResource.getMessage('userlist.ha_editor.customers.title'),
            nameColumnHeaderTitle: messageResource.getMessage('userlist.ha_editor.customers.name_column_header'),
            countersColumnHeaderTitle: messageResource.getMessage('userlist.ha_editor.customers.counters_column_header'),
            assignAllLabel: this.params.getAssignAllTextsMap()[HierarchyLevels.CUSTOMER],
            unassignAllLabel: this.params.getRevokeAllTextsMap()[HierarchyLevels.CUSTOMER],
            showOnlyActiveSwitch: this.params.showOnlyActiveSwitch,
            onlyActiveSelectedText: messageResource.getMessage('userlist.ha_editor.hide_archived'),
            allStatusesSelectedText: messageResource.getMessage('userlist.ha_editor.show_archived'),
            additionalClass: HIERARCHY_LEVEL_CLASSES[HierarchyLevels.CUSTOMER],
            onAssignAll: () => this.callbacks.changeAllCustomersAssignments(true),
            onUnassignAll: () => this.callbacks.changeAllCustomersAssignments(false),
            onOnlyActiveChanged: onlyActive => this.callbacks.changeOnlyActive(onlyActive),
            onSearchTextChanged: text => this.callbacks.changeCustomersSearchText(text),
            hideSearch: () => this.callbacks.clearCustomersSearchText(),
            workAssignmentsVisible: this.params.workAssignmentsVisible,
            managementAssignmentsEditable: this.params.managementAssignmentsEditable,
        }).init($content)

        this.customersList = new EntitiesList({
            hierarchyLevel: HierarchyLevels.CUSTOMER,
            showProjectsCount: true,
            showTasksCount: true,
            entitiesClickable: true,
            workAssignmentsVisible: this.params.workAssignmentsVisible,
            managementAssignmentsEditable: this.params.managementAssignmentsEditable,
            revokeMenu: this.revokeMenu,
            revokeMenuTextsMaps: {
                assignTextsMap: this.params.getAssignTextsMap(),
                revokeTextsMap: this.params.getRevokeTextsMap(),
            },
            onAssignmentChange: (customerId, assigned) => this.callbacks.changeCustomerAssignment(customerId, assigned),
            onEntityClick: customerId => this.callbacks.selectCustomer(customerId),
            checkIfViewerCanManage: customerId => {
                return !!this.state.viewerCanManageCustomerIds[customerId]
            }
        })

        this.projectsListHeader = new EntitiesListHeader({
            title: messageResource.getMessage('userlist.ha_editor.projects.title'),
            nameColumnHeaderTitle: messageResource.getMessage('userlist.ha_editor.projects.name_column_header'),
            countersColumnHeaderTitle: messageResource.getMessage('userlist.ha_editor.projects.counters_column_header'),
            assignAllLabel: this.params.getAssignAllTextsMap()[HierarchyLevels.PROJECT],
            unassignAllLabel: this.params.getRevokeAllTextsMap()[HierarchyLevels.PROJECT],
            showOnlyActiveSwitch: this.params.showOnlyActiveSwitch,
            onlyActiveSelectedText: messageResource.getMessage('userlist.ha_editor.hide_archived'),
            allStatusesSelectedText: messageResource.getMessage('userlist.ha_editor.show_archived'),
            titleMessageSwitcher: this.params.showAllExistingFuturesSwitcher ? messageResource.getMessage('userlist.ma_editor.all_existin_and_future_project_title') : '',
            additionalClass: HIERARCHY_LEVEL_CLASSES[HierarchyLevels.PROJECT],
            onAssignAll: () => this.callbacks.changeAllProjectsAssignments(true),
            onUnassignAll: () => this.callbacks.changeAllProjectsAssignments(false),
            onOnlyActiveChanged: onlyActive => this.callbacks.changeOnlyActive(onlyActive),
            onChangeExistingAndFutureAssignment: assigned => this.callbacks.changeAllExistingAndFutureProjectsAssignment(assigned),
            onSearchTextChanged: text => this.callbacks.changeProjectsSearchText(text),
            hideSearch: () => this.callbacks.clearProjectsSearchText(),
            workAssignmentsVisible: this.params.workAssignmentsVisible,
            managementAssignmentsEditable: this.params.managementAssignmentsEditable,
        }).init($content)
        this.projectsList = new EntitiesList({
            hierarchyLevel: HierarchyLevels.PROJECT,
            showProjectsCount: false,
            showTasksCount: true,
            entitiesClickable: true,
            workAssignmentsVisible: this.params.workAssignmentsVisible,
            managementAssignmentsEditable: this.params.managementAssignmentsEditable,
            revokeMenu: this.revokeMenu,
            revokeMenuTextsMaps: {
                assignTextsMap: this.params.getAssignTextsMap(),
                revokeTextsMap: this.params.getRevokeTextsMap(),
            },
            onAssignmentChange: (projectId, assigned) => this.callbacks.changeProjectAssignment(projectId, assigned),
            onEntityClick: projectId => this.callbacks.selectProject(projectId),
            checkIfViewerCanManage: projectId => !!this.state.viewerCanManageProjectIds[projectId],
        })

        this.tasksListHeader = new EntitiesListHeader({
            title: messageResource.getMessage('userlist.ha_editor.tasks.title'),
            nameColumnHeaderTitle: messageResource.getMessage('userlist.ha_editor.tasks.name_column_header'),
            assignAllLabel: this.params.getAssignAllTextsMap()[HierarchyLevels.TASK],
            unassignAllLabel: this.params.getRevokeAllTextsMap()[HierarchyLevels.TASK],
            showOnlyActiveSwitch: this.params.showOnlyActiveSwitch,
            onlyActiveSelectedText: messageResource.getMessage('userlist.ha_editor.hide_completed'),
            allStatusesSelectedText: messageResource.getMessage('userlist.ha_editor.show_completed'),
            titleMessageSwitcher: this.params.showAllExistingFuturesSwitcher ? messageResource.getMessage('userlist.ma_editor.all_existin_and_future_task_title') : '',
            additionalClass: HIERARCHY_LEVEL_CLASSES[HierarchyLevels.TASK],
            onAssignAll: () => this.callbacks.changeAllTasksAssignments(true),
            onUnassignAll: () => this.callbacks.changeAllTasksAssignments(false),
            onOnlyActiveChanged: onlyActive => this.callbacks.changeOnlyActive(onlyActive),
            onSearchTextChanged: text => this.callbacks.changeTasksSearchText(text),
            onChangeExistingAndFutureAssignment: assigned => this.callbacks.changeAllExistingAndFutureTasksAssignment(assigned),
            hideSearch: () => this.callbacks.clearTasksSearchText(),
            workAssignmentsVisible: this.params.workAssignmentsVisible,
            managementAssignmentsEditable: this.params.managementAssignmentsEditable,
        }).init($content)
        this.tasksList = new EntitiesList({
            hierarchyLevel: HierarchyLevels.TASK,
            showProjectsCount: false,
            showTasksCount: false,
            entitiesClickable: true,
            workAssignmentsVisible: this.params.workAssignmentsVisible,
            managementAssignmentsEditable: this.params.managementAssignmentsEditable,
            revokeMenu: this.revokeMenu,
            revokeMenuTextsMaps: {
                assignTextsMap: this.params.getAssignTextsMap(),
                revokeTextsMap: this.params.getRevokeTextsMap(),
            },
            onAssignmentChange: (taskId, assigned) => this.callbacks.changeTaskAssignment(taskId, assigned),
            checkIfViewerCanManage: taskId => true,
            onEntityClick: taskId => {
                const disabled = !this.params.workAssignmentsVisible && this.state.futureTasksAssigned ||
                                 !this.params.managementAssignmentsEditable && !!this.state.canManageTaskIds[taskId] ||
                                 !this.params.workAssignmentsVisible && this.state.canManageParentProject
                if (!disabled)
                    this.callbacks.changeTaskAssignment(
                        taskId,
                        this.params.workAssignmentsVisible && !this.state.canWorkTaskIds[taskId]
                        || !this.params.workAssignmentsVisible && !this.state.canManageTaskIds[taskId]
                    )
            },
        })

        this.loadingSpinner = new LoadingSpinner({})
        this.loadingSpinnerWrapper = new LoadingSpinnerWrapper(this.loadingSpinner)

        this.listsLoadingWrapper = new LoadingContainer({
            contentComponent: [
                this.customersList,
                this.projectsList,
                this.tasksList,
                this.loadingSpinnerWrapper
            ],
            containerClass: 'entitiesListLoadingWrapper'
        })

        this.scrollableWrapper = new AutoScrollableWrapper({
            components: [this.listsLoadingWrapper],
            enableVerticalScroll: true,
            verticalScrollConfig: {
                probeType: 2
            },
            onScrollToBottom: () => this.callbacks.loadMoreEntities()
        }).init(this.find('.lists'))
    }

    show() {
        super.show()
        this.scrollableWrapper.show()
    }

    _tryToShowNotFoundMessage() {
        let currentEntities
        let msg = ""
        const isSearching = !!this.state.searchText
        const onlyActive = this.state.onlyActive

        if (!this.state.selectedCustomer && !this.state.selectedProject) {
            currentEntities = this.state.customers
            msg = messageResource.getMessage('common.customers_not_found_message')
        } else if (!!this.state.selectedCustomer && !this.state.selectedProject) {
            currentEntities = this.state.projects
            msg = isSearching ?
                  messageResource.getMessage('common.projects_not_found_message') :
                  onlyActive ? messageResource.getMessage('assigned_users_editor.disabled_tooltip.no_projects_active')
                             : messageResource.getMessage('assigned_users_editor.disabled_tooltip.no_projects')
        } else {
            currentEntities = this.state.tasks
            msg = isSearching ?
                  messageResource.getMessage('common.tasks_not_found_message') :
                  onlyActive ? messageResource.getMessage('assigned_users_editor.disabled_tooltip.no_tasks_active')
                             : messageResource.getMessage('assigned_users_editor.disabled_tooltip.no_tasks')
        }

        this.$noFoundMessage.text(msg)
        this.$noFoundMessage.toggle(currentEntities.length === 0)
    }

    _getCannotChangeThisOption({targetCP}) {
        return messageResource.getMessage('user.panel.permissions.team_assignments.cannot_change_this_option', [targetCP])
    }

    _getCannotChangeThisOptionExistingAndFuture({existingAndFutures, selectedCP}) {
        return messageResource.getMessage(
            'user.panel.permissions.team_assignments.cannot_change_this_option_existing_and_future',
            [existingAndFutures, selectedCP]
        )
    }

    _getCannotUnassign({targetPT, selectedCP}) {
        return messageResource.getMessage(
            'user.panel.permissions.team_assignments.cannot_unassign',
            [targetPT, selectedCP]
        )
    }

    _getCannotUnassignExistingAndFutures({targetPT, existingAndFutures, selectedCP}) {
        return messageResource.getMessage(
            'user.panel.permissions.team_assignments.cannot_unassign_existing_and_future',
            [targetPT, existingAndFutures, selectedCP]
            )
    }

    _setHierarchyBackButtonText(selectedCustomer, selectedProject) {

        if(!selectedCustomer && !selectedProject) {
            this.$backButtonText.text(messageResource.getMessage("user.panel.permissions.team_assignments.back"))
        }

        if(!!selectedCustomer && !selectedProject) {
            this.$backButtonText.text(messageResource.getMessage("user.panel.permissions.team_assignments.back_to_customer"))
        }

        if(!!selectedCustomer && !!selectedProject) {
            this.$backButtonText.text(messageResource.getMessage("user.panel.permissions.team_assignments.back_to_project"))
        }

        this.$backButton.toggleClass('wideBackButton', (!!selectedCustomer && !selectedProject) ||
                                                       (!!selectedCustomer && !!selectedProject))
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/HierarchyAssignmentsEditor.js